import FinancialInfoCard from './FinancialInfoCardContainer';

export default FinancialInfoCard;
